import SapJobStatusBadge from '@/components/sapJobs/SapJobStatusBadge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatIsoDateTime } from '@/lib/sapJobStatus';

export default function SapJobMonitoringPanel({ monitoring, snapshotStatus }) {
  const mon = monitoring;
  return (
    <Card data-testid="sap-job-monitoring-tab">
      <CardHeader>
        <CardTitle>Monitoring checkpoint</CardTitle>
      </CardHeader>
      <CardContent className="text-sm space-y-2">
        {!mon?.available ? (
          <p className="text-muted-foreground" data-testid="monitoring-unavailable">
            No active monitoring checkpoint
          </p>
        ) : (
          <>
            <div>
              <span className="text-muted-foreground">Stage</span>
              {': '}
              <SapJobStatusBadge sapStatus={snapshotStatus} monitoringStage={mon.stage} />
            </div>
            <div><span className="text-muted-foreground">Identity phase</span>: {mon.identity_phase || '—'}</div>
            <div><span className="text-muted-foreground">Status</span>: {mon.status || '—'}</div>
            <div><span className="text-muted-foreground">Next check</span>: {formatIsoDateTime(mon.next_check_at)}</div>
            <div><span className="text-muted-foreground">Last checked</span>: {formatIsoDateTime(mon.last_checked_at)}</div>
            <div><span className="text-muted-foreground">Expected finish</span>: {formatIsoDateTime(mon.expected_finish_at)}</div>
            <div><span className="text-muted-foreground">Attempt count</span>: {mon.attempt_count ?? '—'}</div>
          </>
        )}
      </CardContent>
    </Card>
  );
}
